import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';

import withPermissions from '../../../auth/utils/withPermissions';
import { canUserModifyStaffManagement } from '../../../common/helpers/users';
import BarbersPageTabs from '../../barbers/barbersWrapper/barbersPageTabs';
import SimpleHeader from '../../headers/simpleHeader';
import AddButton from '../../../common/buttons/buttonLink';
import StaffList from './StaffListContainer';
import { getUserUrlPrefix } from '../../../auth/selectors';
import { t } from '../../../../modules/infra/i18n';

const StaffListWrapper = ({ canModifyStaff, addStaffLink }) => (
  <div>
    <SimpleHeader heading={t('barber:staff.wrapper.heading')}>
      <div>
        <AddButton
          display-if={canModifyStaff}
          content={t('barber:staff.wrapper.add_staff_button')}
          link={addStaffLink}
          inHeader
        />
      </div>
    </SimpleHeader>
    <div className="c-wrapper o-page-height">
      <BarbersPageTabs />
      <StaffList />
    </div>
  </div>
);

StaffListWrapper.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  children: PropTypes.node,
  canModifyStaff: PropTypes.bool.isRequired,
  addStaffLink: PropTypes.string,
};

StaffListWrapper.defaultProps = {
  children: null,
  addStaffLink: '',
};

export default compose(
  withRouter,
  withPermissions,
  connect((state) => ({
    addStaffLink: `${getUserUrlPrefix(state)}/staff/add`,
  })),
  withProps((props) => ({
    canModifyStaff: canUserModifyStaffManagement(props.permissions),
  }))
)(StaffListWrapper);
